import React, { useState, useEffect, useRef } from "react";

import { api } from "./pureFunctions";
import "./styles/projektstatus.css";
import { header, host } from "./globalVariables";

import Nutzergrafik from "./Nutzergrafik";
import { getStaticData, parseOODate } from "./pureFunctions";
import NutzergrafikObjektverlauf from "./NutzergrafikObjektverlauf";
import StatistikOptionen from "./StatistikOptionen";
import { useConfig } from "./ConfigContext";

const years = [2026, 2025, 2024];

export default function VerkaufStatistik({}) {
   const config = useConfig();
   const [selectedUser, setSelectedUser] = useState();
   const [loading, setLoading] = useState(false);
   const [estates, setEstates] = useState([]);
   const [auftragsDatumEstates, setAuftragsDatumEstates] = useState();
   const [verkaufsDatumEstates, setVerkaufsDatumEstates] = useState();
   // const [verkaufsDatumEstates2025, setVerkaufsDatumEstates2025] = useState([]);
   const [users, setUsers] = useState();
   const [timeLimits, setTimeLimits] = useState(() => {
      const oldOptions = JSON.parse(localStorage.getItem("nutzerauswertungTimelimits"));
      return false ? oldOptions : { start: new Date(), end: new Date(new Date().getTime() + 86400000) };
   });

   const [benutzerListOptionen, setBenutzerListOptionen] = useState(() => {
      const oldOptions = JSON.parse(localStorage.getItem("vkStatList"));

      return oldOptions ? oldOptions : {};
   });
   const [benutzerOptionen, setBenutzerOptionen] = useState(() => {
      const oldOptions = JSON.parse(localStorage.getItem("vkStat"));
      console.log(oldOptions);

      return oldOptions ? oldOptions : "exkl";
   });

   useEffect(() => {
      localStorage.setItem("vkStat", JSON.stringify(benutzerOptionen));
      localStorage.setItem("vkStatList", JSON.stringify(benutzerListOptionen));
   }, [benutzerListOptionen, benutzerOptionen]);

   async function getEstates(params) {
      let parameters = structuredClone(config.stats.vk.parameters);
      parameters.filter.status2 = [
         {
            op: "IN",
            val: Object.keys(config.stats.vk.aktuell),
         },
      ];

      if (benutzerListOptionen && Object.keys(benutzerListOptionen).length) {
         parameters.filter.benutzer = [
            {
               op: benutzerOptionen === "inkl" ? "IN" : "NOT IN",
               val: Object.keys(benutzerListOptionen).map((item) => item),
            },
         ];
      }
      console.log(parameters);

      await api.post("/api/readEstates", { parameters }, header).then((data) => {
         console.log(data.data);
         setEstates(data.data);
      });
   }

   async function getEstatesAuftrag(params) {
      let parameters = structuredClone(config.stats.vk.parameters);
      parameters.filter.status2 = [
         {
            op: "IN",
            val: Object.keys(config.stats.vk.stufen),
         },
      ];
      if (benutzerListOptionen && Object.keys(benutzerListOptionen).length) {
         parameters.filter.benutzer = [
            {
               op: benutzerOptionen === "inkl" ? "IN" : "NOT IN",
               val: Object.keys(benutzerListOptionen).map((item) => item),
            },
         ];
      }
      if (true) {
         //Auftrag seit
         // parameters.filter.verkauft_am = [{ op: "BETWEEN", val: params.timespan }];
         parameters.filter[config.estate.auftragsdatum] = [{ op: "BETWEEN", val: params.timespan }];
      }
      let newEstatesAll = [];
      let i = 0;
      let estateResponse;
      /* do {
         console.log(parameters); */
      estateResponse = await api.post("/api/readEstates", { parameters }, header).then((data) => {
         console.log(data.data);
         return data.data;
      });

      /*  newEstatesAll.push(...estateResponse);
         i++;
         parameters.listoffset = 500 * i;
         console.log(estateResponse.length);
      } while (estateResponse.length >= 500); */

      setAuftragsDatumEstates((prev) => ({ ...prev, [params.year]: estateResponse }));
   }

   /* async function getEstatesVerkauf2025(params) {
      let parameters = {
         data: ["objektnr_extern", "status2", "benutzer"],
         filter: {
            status2: [
               {
                  op: "IN",
                  val: ["verkauft"],
               },
            ],
         },
         listlimit: 500,
         listoffset: 0,
         sortby: { objektnr_extern: "DESC" },
      };
      if (benutzerListOptionen && Object.keys(benutzerListOptionen).length) {
         parameters.filter.benutzer = [
            {
               op: benutzerOptionen === "inkl" ? "IN" : "NOT IN",
               val: Object.keys(benutzerListOptionen).map((item) => item),
            },
         ];
      }
      if (true) {
         //verkauft am
         parameters.filter.verkauft_am = [{ op: "BETWEEN", val: ["2024-01-01", "2025-01-01"] }];
      }
      let newEstatesAll = [];
      let i = 0;
      let estateResponse;
      do {
         console.log(parameters);
         estateResponse = await api.post("/api/readEstates", { parameters }, header).then((data) => {
            console.log(data.data);
            return data.data;
         });

         newEstatesAll.push(...estateResponse);
         i++;
         parameters.listoffset = 500 * i;
         console.log(estateResponse.length);
      } while (estateResponse.length >= 500);

      setVerkaufsDatumEstates2025(newEstatesAll);
   } */

   async function getData() {
      let [newestatekacheln, cleanUserData, newfieldConfiguration] = await getStaticData();

      console.log(cleanUserData);

      setUsers(cleanUserData.userObject);

      await getEstates("current");

      if (config.company === "baur") {
         years.forEach((yearItem) => {
            getEstatesAuftrag({ year: yearItem, timespan: [yearItem + "-01-01", yearItem + 1 + "-01-01"] });
         });
      }
      /* config.company === "baur" && (await getEstatesAuftrag({ year: "2024", timespan: ["2024-01-01", "2025-01-01"] }));
      config.company === "baur" && (await getEstatesAuftrag({ year: "2025", timespan: ["2025-01-01", "2026-01-01"] }));
      config.company === "baur" && (await getEstatesAuftrag({ year: "2026", timespan: ["2026-01-01", "2027-01-01"] })); */
      // config.company === "baur" && (await getEstatesVerkauf2025());
   }

   useEffect(() => {
      setLoading(true);
      getData();

      setLoading(false);
   }, []);

   return (
      <>
         <title>Nutzerauswertung</title>
         <StatistikOptionen
            userObjects={users}
            benutzerOptionen={benutzerOptionen}
            setBenutzerOptionen={setBenutzerOptionen}
            benutzerListOptionen={benutzerListOptionen}
            setBenutzerListOptionen={setBenutzerListOptionen}
            timeLimits={timeLimits}
            setTimeLimits={setTimeLimits}
            getData={getData}
            initialshow={false}
            placement={"start"} //'start', 'end', 'top', 'bottom'
         />
         <div className="projektstatus p-0">
            <div className="projektstatus-l1">
               <div className="">
                  {!loading && (
                     <Nutzergrafik
                        users={users}
                        estates={estates}
                        selectedUser={selectedUser}
                        setSelectedUser={setSelectedUser}
                        statConfig={config.stats.vk}
                     />
                  )}

                  {!loading &&
                     config.company === "baur" &&
                     auftragsDatumEstates &&
                     years.map((item) => {
                        if (auftragsDatumEstates[item] && auftragsDatumEstates[item].length > 0) {
                           return (
                              <NutzergrafikObjektverlauf
                                 users={users}
                                 year={item}
                                 auftragsDatumEstates={auftragsDatumEstates[item]}
                                 // verkaufsDatumEstates={verkaufsDatumEstates2025}
                                 selectedUser={selectedUser}
                                 stufen={config.stats.vk.stufen}
                                 setSelectedUser={setSelectedUser}
                              />
                           );
                        }
                     })}

                  {/* {!loading &&
                     config.company === "baur" &&
                     auftragsDatumEstates &&
                     auftragsDatumEstates["2024"] &&
                     auftragsDatumEstates["2024"].length > 0 && (
                        <NutzergrafikObjektverlauf
                           users={users}
                           year={"2024"}
                           auftragsDatumEstates={auftragsDatumEstates["2024"]}
                           verkaufsDatumEstates={verkaufsDatumEstates2025}
                           selectedUser={selectedUser}
                           stufen={config.stats.vk.stufen}
                           setSelectedUser={setSelectedUser}
                        />
                     )} */}

                  {/* {!loading &&
                     config.company === "baur" &&
                     auftragsDatumEstates &&
                     auftragsDatumEstates["2025"] &&
                     auftragsDatumEstates["2025"].length > 0 && (
                        <NutzergrafikObjektverlauf
                           users={users}
                           year={"2025"}
                           auftragsDatumEstates={auftragsDatumEstates["2025"]}
                           verkaufsDatumEstates={verkaufsDatumEstates2025}
                           selectedUser={selectedUser}
                           setSelectedUser={setSelectedUser}
                           stufen={config.stats.vk.stufen}
                        />
                     )} */}
               </div>
            </div>
         </div>
      </>
   );
}
